import { render, staticRenderFns } from "./CompleteRegister.vue?vue&type=template&id=7c22cf24&scoped=true"
import script from "./CompleteRegister.vue?vue&type=script&lang=js"
export * from "./CompleteRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22cf24",
  null
  
)

export default component.exports